import { render, staticRenderFns } from "./statisticChart.vue?vue&type=template&id=1abb726e&scoped=true"
import script from "./statisticChart.vue?vue&type=script&lang=js"
export * from "./statisticChart.vue?vue&type=script&lang=js"
import style0 from "./statisticChart.vue?vue&type=style&index=0&id=1abb726e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abb726e",
  null
  
)

export default component.exports